"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = require("primereact/button");
const utils_1 = require("primereact/utils");
const AsyncButton = (props) => {
    const { content, isFetching, isFullWidth, fetchingIcon: _fetchingIcon, ...rest } = props;
    const fetchingIcon = _fetchingIcon ?? ((0, jsx_runtime_1.jsx)("span", { className: 'w-full', children: (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-spinner pi-spin' }) }));
    return ((0, jsx_runtime_1.jsx)(button_1.Button, { ...rest, className: (0, utils_1.classNames)(props.className, { 'w-full': isFullWidth }), label: isFetching ? undefined : props.label, children: isFetching ? fetchingIcon : content }));
};
exports.AsyncButton = AsyncButton;
exports.AsyncButton.defaultProps = {
    isFullWidth: true,
    isFetching: false,
};
